<template>
    <f-dialog
        v-model       = "show"
        :width        = "550"
        :show-header  = "true"
        :hide-actions = "false"
        :inset        = "true"
        content-class = "dialog-border"
        :title        = "$t('disposition.report.title')"
        :show-save    = "false"
        :show-delete  = "false"
        :show-cancel  = "false"
        @cancel       = "onCancel"
    >
        <template v-slot:preaction>
            <div class="v-flex w-100 mr-2">
                <v-spacer />
                <div class = "download-label">
                    {{ $t('disposition.report.create.date') + ":" }}
                </div>
                <div class="download-date-select">
                    <v-select
                        class   = "pt-0 create-date-entry"
                        v-model = "dates.download.selected"
                        :items  = "dates.download.items"
                        hide-details
                    >
                        <template v-slot:item="{ item }">
                            {{ formatDate(item) }}
                        </template>
                        <template v-slot:selection="{ item }">
                            {{ formatDate(item) }}
                        </template>
                    </v-select>
                </div>

                <v-btn
                    :disabled = "!dates.download.selected || createReports"
                    class     = "dialog-button primary"
                    @click    = "onExport"
                    depressed
                >
                    Download
                </v-btn>
            </div>
        </template>
        <template v-slot:content>
            <div class="mode-radio-group">
                <div style="position: absolute; right: 0; top: 36px;z-index: 100">
                    <v-checkbox
                        v-model = "recalculate"
                        :label  = "$t('audit.rebuild.label')"
                        :ripple = "false"
                        class   = "pt-0 mt-0"

                        hide-details
                    />
                </div>
                <v-radio-group v-model="createMode" hide-details>
                    <v-radio
                        :label="$t('disposition.report.create.mode.allDocuments')"
                        value="allDocuments"
                    />
                    <v-radio
                        :label="$t('disposition.report.create.mode.newDocuments')"
                        value="newDocuments"
                    />
                    <v-radio
                        :label="$t('disposition.report.create.mode.currentDocuments')"
                        value="currentDocuments"
                    />
                    <v-radio
                        v-if="dates.created.items.length > 0"
                        :label="$t('disposition.report.create.mode.dateDocuments')"
                        value="dateDocuments"
                    />
                </v-radio-group>

                <div
                    v-if  ="dates.created.items.length > 0 && createMode === 'dateDocuments'"
                    class = "create-date-select"
                >
                    <v-select
                        v-model = "dates.created.selected"
                        :items  = "dates.created.items"
                        :label  = "$t('disposition.report.create.mode.allDocuments')"
                        @input  = "onCreateDate"
                        hide-details
                    >
                        <template v-slot:item="{ item }">
                            {{ formatDate(item) }}
                        </template>
                        <template v-slot:selection="{ item }">
                            {{ formatDate(item) }}
                        </template>
                    </v-select>
                </div>

                <div class="create-button">
                    <v-btn
                        :disabled = "!createMode || createReports"
                        class     = "dialog-button primary"
                        @click    = "onPrint"
                        depressed
                    >
                        {{ $t("disposition.report.create.button") }}
                    </v-btn>
                </div>
            </div>

            <v-divider class="mt-2 mb-3" />

            <v-progress-linear
                v-model = "done.percentage"
                color   = "primary"
                :height = "20"

                rounded
            >
                <div
                    v-if  = "inspections.display"
                    class = "progress-label"
                >
                    {{ done.count }} / {{ inspections.display.length }}
                </div>

            </v-progress-linear>
            <c-card-iterator
                v-if               = "inspections.display"
                :items             = "inspections.display"
                :item-gap          = "0"
                :filter-height     = "0"
                :height            = "400"
                :item-height       = "50"
                key-field          = "id"
                :zoom              = "false"
                :left-arrow        = "false"
                :refresh-on-filter = "false"
                :show-count        = "false"
                :enable-search     = "false"
                :show-title        = false
                scroller-type      = "default"
                ref                = "iterator"
            >
                <template v-slot:card="{ item }">
                    <p-inspection-report-card
                        :inspection = "item.data"
                        @print      = "onPrintSingle"
                    />
                    <v-divider class="mt-2" />
                </template>
            </c-card-iterator>
        </template>
    </f-dialog>
</template>

<script>

import Core                  from "@/modules/core/service/Core";
import Order                 from "@/modules/dis/service/order/Order";
import Disposition           from "@/modules/dis/service/Disposition";
import FDialog               from "@/modules/core/components/utils/FDialog.vue";
import CCardIterator         from "@/modules/core/components/utils/CCardIterator.vue";
import PInspectionReportCard from "@/modules/dis/components/order/overview/private/PInspectionReportCard.vue";

export default {
    name: "PInspectionReport",

    components: {
        PInspectionReportCard,
        CCardIterator,
        FDialog,
    },

    props: {
        value: {

        },

        order: {

        }
    },

    data: () => ({
        show: false,
        recalculate: false,
        inspections: {
            data   : [],
            display: []
        },

        dates: {
            created : {
                selected: null,
                items   : []
            },
            download: {
                selected: null,
                items   : []
            }
        },

        done: {
            count: 0,
            percentage: null
        },

        createMode: null,
        createReports: false,
    }),

    computed: {
    },

    mounted() {
        this.show = this.value;
        this.load();
    },

    watch: {
        value () {
            this.show = this.value;
            this.load();
        },

        createMode () {
            this.onFilter();
        }
    },

    methods: {
        /**
         *
         * @return {Promise<void>}
         */
        async onPrint () {
            this.createReports = true;
            for (const inspection of this.inspections.display) {
                if (!this.show) {
                    return;
                }

                const update = this.createMode === 'dateDocuments';
                await Order.report.inspection(inspection.orderId, update, inspection.id, this.recalculate).then (updated => {
                    inspection.created = updated.created;
                    inspection.printed = updated.printed;
                });

                this.done.count ++;
                this.done.percentage = Math.ceil(this.done.count * 100 / this.inspections.display.length);
            }
            this.createReports = false;
        },

        /**
         *
         * @param inspection
         * @return {Promise<void>}
         */
        async onPrintSingle (inspection) {
            if (!this.show) {
                return;
            }

            Core.loading(this, true, this.$t("disposition.report.create.waiting"));
            await Order.report.inspection(inspection.orderId, true, inspection.id, this.recalculate).then (updated => {
                const modified = this.inspections.display.find(i => i.id === inspection.id);
                modified.created = updated.created;
                modified.printed = updated.printed;
                Core.loading(this, false);
            }).catch(() => {
                Core.loading(this, false);
            });
        },

        /**
         *
         */
        onExport () {
            if (this.done.count > 0 && this.done.count < this.inspections.length) {
                Core.message.error(this, this.$t("disposition.report.download.inProcess"));
                return;
            }

            Core.loading(this, true, this.$t("disposition.order.reports.documents.loading"));
            const date = this.dates.download.selected === this.dates.download.items[0] ? null : this.dates.download.selected;
            Disposition.order.download(this.order.id, date, (blob) => {
                const link = document.createElement("a");
                link.href = blob;
                link.download = this.order.no + ".zip";
                link.click();
                Core.loading(this, false);
            }, (error => {
                console.error("error", error);
                Core.loading(this, false);
            }));
        },

        /**
         *
         */
        onCancel () {
            this.$emit("input", false);
        },

        /**
         *
         */
        onFilter () {
            this.inspections.display = [];
            this.inspections.data.forEach(inspection => {
                switch (this.createMode) {
                    case "allDocuments":
                        this.inspections.display.push(inspection);
                        break;
                    case "newDocuments":
                        if (!inspection.created) {
                            this.inspections.display.push(inspection);
                        }
                        break;
                    case "currentDocuments":
                        if (inspection.created) {
                            this.inspections.display.push(inspection);
                        }
                        break;
                    case "dateDocuments":
                        if (inspection.created === this.dates.created.selected) {
                            this.inspections.display.push(inspection);
                        }
                        break;
                }
            })
        },

        onCreateDate () {
            this.onFilter();
        },

        /**
         *
         */
        load () {
            this.done.count =0;
            this.done.percentage = 0;
            this.createMode = null;
            this.createReports = false;
            this.dates.download.selected = null;
            this.dates.created.selected = null;

            if (!this.show || !this.order) {
                return;
            }

            Disposition.order.findAvailibleReports(this.order.id).then (data => {
                this.inspections.data = data;
                this.onFilter();
                this.dates.download.items = [];
                this.dates.created.items = [];

                const dates = [...new Set(this.inspections.data.map(inspection => inspection.created).filter(created => !!created))];
                dates.sort((l,r) => r.localeCompare (l));

                this.dates.download.items.push("disposition.report.download.all");
                dates.forEach(d => this.dates.download.items.push(d));
                dates.forEach(d => this.dates.created.items.push(d));

                if (this.dates.created.items.length > 0) {
                    this.dates.created.selected = this.dates.created.items[0]
                }

                this.dates.download.selected = this.dates.download.items[0]
            });
        },

        /**
         *
         * @param value
         * @return {string|*|string|VueI18n.TranslateResult}
         */
        formatDate (value) {
            if (value && value === "disposition.report.download.all") {
                return this.$t(value);
            }

            return Core.format.date.display(value)
        }
    }
}
</script>

<style scoped>

.create-date-select {
    position: absolute;
    bottom: 0;
    right: 4px;
    width: 145px
}

.create-date-entry {
    font-size: 15px;
}

.create-button  {
    position: absolute;
    top: 0;
    right: 12px;
    width: 140px
}

.progress-label {
    font-size: 12px;
    color: white
}

.download-label {
    margin-right: 8px;
    padding-top: 2px;
    font-size: 15px;
}

.download-date-select {
    width: 180px;
    margin-right: 8px;
    margin-top: -7px;
}

.mode-radio-group {
    position: relative;
    margin-top: -8px;
}

</style>